import React from 'react'
import {Space} from 'antd'
import styles from './UploadControl.module.scss'
import {useComponentLocale} from '../hooks/useComponentLocale'
import {humanFileSize} from "../helpers/helpers";

function UploadDataInfo({uploadProgress}) {
    const getLocale = useComponentLocale()
    const processedLocale = getLocale({component: 'tags', section: 'processed'})
    const duplicatesLocale = getLocale({component: 'tags', section: 'duplicates'})
    const stackOutOfRangeLocale = getLocale({component: 'tags', section: 'stack_out_of_range'})
    const notInSpotListLocale = getLocale({component: 'tags', section: 'not_in_spot_list'})

    return (
        <>
            {uploadProgress ? (
                <div className={styles.uploadData}>
                    <Space>
                        <span>
                            Uploading files:{' '}
                            <span className={styles.valueText}>{humanFileSize(uploadProgress.loaded)} / {humanFileSize(uploadProgress.total)}</span>
                        </span>
                    </Space>
                </div>
            ) : null}
        </>
    )
}

export default UploadDataInfo
